<template>
    <v-dialog 
        v-model="mbs_dialog.show" 
        :max-width="mbs_dialog.size?mbs_dialog.size:500"                     
        :persistent='mbs_dialog.fixed'  >
        <v-card >
            <v-card-title class="headline"
                primary-title >
                {{mbs_dialog.title}}
            </v-card-title> 
            <v-card-text style="white-space: pre-line">
                {{mbs_dialog.text}}
            </v-card-text> 
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="mbs_dialog.btnNo"
                    @click="onNotNo"
                    color="blue" 
                    text="">
                    {{mbs_dialog.btnNo}}
                </v-btn>
                <v-btn v-if="mbs_dialog.btnYes"
                    @click="onNotYes"
                    color="blue" 
                    text="">
                    {{mbs_dialog.btnYes}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    let NAME = 'DIALOG'
export default {
    props:['notShow'], 
    data(){
        return{
            show:false
        } 
    }, 
    computed:{
        mbs_dialog(){
            return  this.$store.getters.getMBS_dialog
        }
    },
    methods:{
        onNotNo(){ 
            this.MBS.events.$emit('DIALOG_NO',{
                ...this.mbs_dialog.action,
                NO:true,
                YES:false
            }) 
            this.MBS.events.$emit('DIALOG_YES',{
                ...this.mbs_dialog.action,
                NO:true,
                YES:false
            }) 
            this.$store.dispatch('setMBS_dialog',{})
        },
        onNotYes(){ 
            this.MBS.events.$emit('DIALOG_YES',{
                ...this.mbs_dialog.action,
                NO:false,
                YES:true
            }) 
            this.$store.dispatch('setMBS_dialog',{}) 
        }
    },
    watch:{
        mbs_dialog(value){ 
        },   
    } 
}
</script>
